import React, { useState, useEffect,useRef} from 'react';
import { useLocation } from 'react-router-dom';
import styles from './home.module.scss';
import { SearchBar, Picker, List, ActivityIndicator, ListView, PullToRefresh, Modal, TabBar, Toast, Button } from 'antd-mobile';
import { createFromIconfontCN } from '@ant-design/icons';
import { ApiCore } from '../../api/index';
import defaultAvatar from "../../static/icon/defaultAvatar.svg";
import { Link } from 'react-router-dom';
import creatBtn from '../../static/icon/creat.svg';
import sort_asc from '../../static/icon/sort_asc.svg';
import sort_desc from '../../static/icon/sort_desc.svg';
import sort from '../../static/icon/sort.svg';
import deleteBtn from '../../static/icon/delete.svg';
import mineSelectIcon from '../../static/images/mineSelect.png';
import mineIcon from '../../static/images/mine.png';
import findSelectIcon from '../../static/images/findSelect.png';
import findIcon from '../../static/images/find.png';
import audit_already from '../../static/images/audit_already.png';
import audit_no_pass from '../../static/images/audit_no_pass.png';
import audit_remain from '../../static/images/audit_remain.png';
import icon_completed from '../../static/images/icon-completed.png';
import icon_failed from '../../static/images/icon-failed.png';
import icon_ing from '../../static/images/icon-ing.png';
import icon_not_signed from '../../static/images/icon-not-signed.png';
import icon_reviewed from '../../static/images/icon-reviewed.png';
import icon_to_be_reviewed from '../../static/images/icon-to-be-reviewed.png';
import icon_plus from '../../static/images/icon-plus.png';
import icon_downloda from '../../static/images/icon-plus.png';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';
import icon_rz_fail from '../../static/images/icon_rz_fail.png';
import email_icon from '../../static/images/email_icon.png';
import FindListCom from '../findList/findList';
import { withRouter } from 'react-router-dom';
import { any, reject, resolve } from 'bluebird';
import utils from '../../utils/utils';
import { set } from 'lodash';
import { MessageOutline } from 'antd-mobile-icons';
import ChatModal from '../../component/chat/ChatModal';
import { getSumCount } from '../../api/data';
import Stat from './components/stat';
import QlAlert from './components/ql-alert';

const api = new ApiCore();
const alert = Modal.alert;

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_2343612_adf3x9c88m9.js',
});

let delayExcute: any = null;

function Home(props: any) {
    const location = useLocation();  
    let projectCode = utils.getUrlParams().projectCode;
    let projectName = utils.getUrlParams().projectName;
    projectName = projectName ? decodeURIComponent(projectName) : projectName;

    let token = sessionStorage.getItem('token');
    let mToken: any = {};
    if (token) {
        try {
            mToken = JSON.parse(token);
        } catch (error) {
            mToken = {};
        }
    }

    // 登录账号
    const [account, setAccount] = useState('');
    //设置加载状态
    const [loading, setLoading] = useState(false);
    //设置当前页数
    const [page, setPage] = useState<number>(1);
    //设置pageSize
    const [pageSize, setPageSize] = useState<number>(20);
    //搜索关键字
    const [searchKey, setSearchKey] = useState('');
    //项目list
    const [projectList, setProjectList] = useState([]);
    //状态list
    const [stateList, setStateList] = useState([]);
    //选择的项目
    const [selectProject, setSelectProject] = useState<any>(projectCode ? [projectCode] : []);
    const [selecProjectEntity, setSelecProjectEntity] = useState<any>({});
    //选择的项目
    const [selectProjectName, setSelectProjectName] = useState<any>(projectCode ? projectName : '');
    //选择的状态
    const [selectType, setSelectType] = useState<any>(['All']);
    //受试者列表数据
    const [subjectList, setSubjectList] = useState<Array<any>>([]);
    //是否还有更多数据
    const [isMore, setIsMore] = useState<boolean>(true);
    //当前排序规则
    const [currentSort, setCurrentSort] = useState<any>(null);
    // //下拉刷新状态
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false);
    // 搜索时遮罩层是否打开
    const [isShowMask, setIsShowMask] = useState<boolean>(false);
    //搜索历史记录
    const [record, setRecord] = useState<any>([]);
    // 切换tab
    const [selectedTab, setSelectedTab] = useState<any>('mine');
    // 发现页状态 false-隐藏，true-显示
    const [menuStatus, setMenuStatus] = useState<boolean>(false);
    // 
    const [userId, setUserId] = useState<any>(null);
    //项目加载对应类型映射
    const [projectTypeMap, setProjectTypeMap] = useState({});
    //用户角色，跟用户有关，跟项目有关
    const [roleCode, setRoleCode] = useState('');
    //项目统计
    const [statistics, setStatistics] = useState([]);

    //邮箱地址modal
    const [showEmailModal, setShowEmailModal] = useState(false);
    //邮箱地址
    const [emailAddress, setEmailAddress] = useState('');

    const [hasSign, setHasSign] = useState(props.hasSign);
    // 是否禁用添加受试者
    const [addSubjectReadonly, setAddSubjectReadonly] = useState(false);
    const [ eproProjectCodes, setEproProjectCodes ] = useState<any>([])

    // 特殊code处理
    const [ nameCodes, setNameCodes ] = useState<any>([])

    //目标租户
    const [targetShow, setTargetShow] = useState(false);

    // 显示聊天弹窗
    const [showChatModal, setShowChatModal] = useState(false)
    const [createUserCode, setCreateUserCode] = useState('')
    const [subjectCode, setSubjectCode] = useState('')

    // 齐鲁弹窗提醒
    const [showQlModal, setShowQlModal] = useState(false)
    
    // 受试者名称
    const targetName = sessionStorage.getItem('targetName') || '受试者';

    //悬浮按钮项相关
    let oLeft: any;
    let oTop: any;
    let moving: boolean = false;
    let oW: any;
    let oH: any;
    let htmlWidth: any;
    let htmlHeight: any;
    let bWidth: any;
    let bHeight: any;
    let click: boolean = false;

    let env = process.env.REACT_APP_ENV;

    useEffect(()=>{
        // 报名链接需要用的账号
        const accountInf = localStorage.getItem('accountInf')
        const accounData = accountInf ? JSON.parse(accountInf) : {};
        setAccount(accounData.account);

        // 国耀圣康租户需求
        const tenantCode = localStorage.getItem('tenantCode');
        if (env === 'test' || env === 'development') {
            // 测试环境
           setTargetShow(tenantCode === 'TENANT-0204' ? true:false)
            
        }else {
            // 线上环境
           setTargetShow(tenantCode === 'TENANT-051' ? true:false)   
        }
    },[]);
    useEffect(() => {
        // 受试者绑定的项目特殊处理
        if (env === 'development' || env === 'test') {
            setEproProjectCodes(['PROJECT10000629', 'PROJECT10000623']);
        } else if (env === 'production') {
            setEproProjectCodes(['PROJECT10000556', 'PROJECT10000555', 'PROJECT10000558', 'PROJECT10000557']);
        }
        // 针对041租户，code处理
        if (env === 'development' || env === 'test') {
            setNameCodes(['PROJECT10000823', 'PROJECT10000822']);
        } else if (env === 'production') {
            setNameCodes(['PROJECT10000731', 'PROJECT10000732', 'PROJECT10000733', 'PROJECT10000734']);
        }
        
        let ele = document.getElementById('t-suspend-button');
        let recordStateLocal = localStorage.getItem('recordState');
        if (ele) {
            if (recordStateLocal) {
                let recordState = JSON.parse(recordStateLocal);
                ele.style.left = recordState.actionBall.left;
                ele.style.top = recordState.actionBall.top;
            }
            ele.addEventListener(
                "touchmove",
                e => {
                    if (e.cancelable) {
                        e.preventDefault()
                    }
                },
                {
                    passive: false
                }
            )
        }
        // //设置缓存选择的条件
        // let conditionsStateLocal = localStorage.getItem('conditionsStateLocal');
        // let conditionsState: { selectProject: any; selectType: any; currentSort: any; };
        // if (conditionsStateLocal) {
        //     conditionsState = JSON.parse(conditionsStateLocal);
        // }
        // else {
        //     conditionsState = {
        //         selectProject: [],
        //         selectType: ['All'],
        //         currentSort: null
        //     }
        // }

        // 默认显示 我的患者
        setSelectedTab('mine')

        let localStorage_accountInf = localStorage.getItem('accountInf');
        if (localStorage_accountInf) {
            let accountInf = JSON.parse(localStorage_accountInf);
            // openConfigMenu(accountInf.account)
            setUserId(accountInf.account)
        }
        // 初始化上次选择过的roleCode
        let token = sessionStorage.getItem('token');
        if (token) {
            let mToken = JSON.parse(token);
            if (mToken.roleCode && mToken.roleCode != 'EDC_READ') {
                mToken.roleCode = mToken.roleCode;
            }
        }
        return () => {
        }
    }, [])

    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchKey !== null) {
            delayExcute = setTimeout(() => {
                setPage(1);
                getTasks(1, true);
            }, 300);
        }
    }, [searchKey])

    //是否开启引流功能 
    const openConfigMenu = (userId: any) => {
        let params = {
            userId
        }
        api.GetConfigMenu(params).then(res => {
            if (res.code == '0') {
                setMenuStatus(res.data.menuStatus)
            }
        })
    }

    //当开始触摸
    const onTouchStart = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0];
        click = true;
        if (ele) {
            ele.style.opacity = '1';
            oW = e.clientX - ele?.getBoundingClientRect().left
            oH = e.clientY - ele?.getBoundingClientRect().top
            htmlWidth = document.documentElement.clientWidth
            htmlHeight = document.documentElement.clientHeight
            bWidth = ele.offsetWidth;
            bHeight = ele.offsetHeight;
            oLeft = e.clientX - oW;
            oTop = e.clientY - oH;
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
            moving = true;
        }
    }

    //当触摸结束
    const onTouchEnd = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        moving = false

        // 左侧距离
        let oLeft1 = oLeft;
        if (oLeft1 && oLeft1 < (htmlWidth - bWidth) / 2) {
            oLeft1 = 0
        } else {
            oLeft1 = `${htmlWidth - bWidth}px`
        }
        oLeft = oLeft1
        if (ele) {
            ele.style.left = oLeft;
            let recordState = {
                actionBall: {
                    left: ele.style.left,
                    top: ele.style.top
                }
            }
            localStorage.setItem('recordState', JSON.stringify(recordState));
            setTimeout(() => {
                if (ele) {
                    ele.style.opacity = '0.8'
                }
            }, 2000);
        }
    }

    // 当开始触摸
    const onTouchMove = (e: any) => {
        moving && onMove(e)
    }

    // 当触摸
    const onMove = (e: any) => {
        let ele = document.getElementById('t-suspend-button');
        e = e.touches[0]
        click = false

        // 左侧距离
        let oLeft1 = e.clientX - oW
        let oTop1 = e.clientY - oH
        if (oLeft1 < 0) {
            oLeft1 = 0
        } else if (oLeft1 > htmlWidth - bWidth) {
            oLeft1 = htmlWidth - bWidth
        }
        if (oTop1 < 0) {
            oTop1 = 0
        } else if (oTop1 > htmlHeight - bHeight) {
            oTop1 = htmlHeight - bHeight
        }
        oLeft = oLeft1;
        oTop = oTop1;
        if (ele) {
            ele.style.left = oLeft + 'px';
            ele.style.top = oTop + 'px';
        }
    }


    useEffect(() => {
        //设置网页title
        if (props.updateTitle !== false) {
            document.title = '工作台';
        }
        //设置搜索记录
        let recordLocalStorage = localStorage.getItem('search_history_records');
        if (recordLocalStorage) {
            setRecord(recordLocalStorage.split(','))
        }
        initRoleCondition();
        //获取用户的项目列表
        api.getProject().then(res => {
            if (res.code == '0' && res.data.length > 0) {
                let routeParams = sessionStorage.getItem("activityType")
                let projectKeywordList: any = [];
                const keyword = routeParams === 'TYGJ' ? '同医共济' : routeParams === 'FZCZ' ? '防治卒中' : '';
                if(keyword) {
                    projectKeywordList = res.data.filter((item: any) => item.name.includes(keyword));
                } else {
                    projectKeywordList = res.data.filter((item: any) => !item.name.includes("同医共济") && !item.name.includes("防治卒中"))
                }

                let filterArr: any = [];
                const _projectMap = {};
                for (let item of projectKeywordList) {
                    _projectMap[item.code] = item;
                    filterArr.push(
                        {
                            label: item.name,
                            value: item.code,
                            roleCode: item.roleCode,
                            editModel: item.editModel
                        }
                    )
                }
                setProjectList(filterArr);
                setProjectTypeMap(_projectMap);
                if (projectCode) {
                    onProjectOk([projectCode], _projectMap)
                } else {
                    onProjectOk([filterArr[0].value], _projectMap)
                }

                let defaultItem = _projectMap[filterArr[0].value];
                if (defaultItem && defaultItem.roleCode) {
                    let token = sessionStorage.getItem('token');
                    if (token) {
                        // 每次切换选择更新缓存里的roleCode
                        let mToken = JSON.parse(token);
                        if (mToken.roleCode != 'ReadOnly') {
                            mToken.roleCode = defaultItem.roleCode;
                        }
                        sessionStorage.setItem('token', JSON.stringify(mToken));
                        localStorage.setItem('token', JSON.stringify(mToken));
                    }
                    setRoleCode(defaultItem.roleCode);
                }
            }
        })

        api.getTypeList().then(res => {
            if (res.code == '0' && res.data.length > 0) {
                let filterArr: any = [];
                for (let item of res.data) {
                    // 待入组去除
                    if (item.key !== 'Confirm') {
                        filterArr.push(
                            {
                                label: item.text,
                                value: item.key
                            }
                        )
                    }
                }

                let user = JSON.parse(sessionStorage.getItem('token') + "");
                if (user && (user.tenantCode === "TENANT-013" || user.tenantName === "肠外营养")) {
                    filterArr = [
                        { 'value': 'All', 'label': '全部' },
                        { 'value': 'Input', 'label': '未完成' },
                        { 'value': 'Complete', 'label': '已完成' },
                    ]
                }

                setStateList(filterArr);
            }
        })
        // let _project = projectCode || '';
        // toGetSubjectStatistics(_project);
        getCaseEmail()
    }, [])


     // 是否禁用添加受试者
    const initRoleCondition = () => {
        const token = sessionStorage.getItem('token');
        if (token) {
            try {
                const mToken = JSON.parse(token);
                const mAddSubjectReadonly = (mToken?.roleCodes || []).some((item: any) => item == 'ReadOnly');
                setAddSubjectReadonly(mAddSubjectReadonly);
            } catch (error) {
            }
        }
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchKey(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchKey('');
    }

    //下拉刷新
    const onPullToRefresh = () => {
        setIsPullToRefresh(true);
        let params = {
            page: 1,
            pageSize: pageSize,
            projectCode: selectProject ? selectProject[0] : null,
            type: selectType[0],
            subjectCode: searchKey ? searchKey : null
        }
        //重置状态
        setIsMore(true)
        api.getTasks(params).then(res => {
            if (res.code == '0') {
                let subjectArr = res.data;
                setIsMore(subjectArr.length === pageSize)
                //重置
                setPage(subjectArr.length === pageSize ? 2 : 1);
                setSubjectList(subjectArr);
            }
            setIsPullToRefresh(false);
        })
    }

    //当搜索提交时
    const onsubmit = () => {
        let existing = false;
        record.forEach((recordItem: any, index: any) => {
            if (recordItem === searchKey) {
                record.splice(index, 1, recordItem);
                existing = true;
            }
        })
        if (!existing) {
            if (record.length >= 20) {
                record.splice(0, 1, searchKey);
            }
            else {
                record.unshift(searchKey);
            }
        }
        setRecord(record);
        localStorage.setItem('search_history_records', record.join(','));
        setIsShowMask(false);
        setPage(1);
        getTasks(1, true);
    }
    //当取消搜索时
    const oncancel = () => {
        setSearchKey('');
        setIsShowMask(false);

        setLoading(true);
        let params = {
            page: 1,
            pageSize: pageSize,
            projectCode: selectProject ? selectProject[0] : null,
            type: selectType[0],
            subjectCode: null,
            subjectCodeOrder: currentSort
        }
        //重置状态
        setIsMore(true)
        api.getTasks(params).then(res => {
            if (res.code == '0') {
                let subjectArr = res.data;
                setIsMore(subjectArr.length === pageSize)
                //重置
                setPage(subjectArr.length === pageSize ? 2 : 1);
                setSubjectList(subjectArr);
            }
            setLoading(false);
        })
    }

    //当搜索值改变了
    const onSearchChange = (value: any) => {
        setSearchKey(value)
    }

    //当选了项目
    const onProjectOk = (value: any, _projectTypeMap?: any) => {
   
        // 选中条目
        let item = _projectTypeMap ? _projectTypeMap[value[0]] : projectTypeMap[value[0]];
        setSelecProjectEntity(item)
        // 返回时默认选中之前选中的
        if (props.fromHomeDoctor) {
            if (item) {
                window.history.replaceState({}, document.title, `#/doctor/home?tab=task&projectCode=${item.code}&projectName=${encodeURIComponent(item.name)}`)
            } else {
                window.history.replaceState({}, document.title, '#/doctor/home?tab=task')
            }
        } else {
            if (item) {
                window.history.replaceState({}, document.title, `#/home?projectCode=${item.code}&projectName=${encodeURIComponent(item.name)}`)
                localStorage.setItem("pathHome",`/home?projectCode=${item.code}&projectName=${encodeURIComponent(item.name)}` )
            } else {
                window.history.replaceState({}, document.title, '#/home')
                localStorage.setItem("pathHome",`/home` )
            }
        }
        // 更新用户所属项目角色
        if (item && item.roleCode) {
            let token = sessionStorage.getItem('token');
            if (token) {
                // 每次切换选择更新缓存里的roleCode
                let mToken = JSON.parse(token);
                if (mToken.roleCode != 'EDC_READ') {
                    mToken.roleCode = item.roleCode;
                }
                sessionStorage.setItem('token', JSON.stringify(mToken));
                localStorage.setItem('token', JSON.stringify(mToken));
            }
            setRoleCode(item.roleCode);
        }
        setSelectProject(value);
        setPage(1);
    }

    //当选了类型
    const onTypeOk = (value: any) => {
        setPage(1);
        setSelectType(value);
    }

    //设置排序后的数据列表
    const setSortList = (value: any) => {
        setSubjectList(value);
    }

    //根据条件搜索待处理任务列表
    const getTasks = (currentPage?: number, isReset?: boolean) => {
        if (selectProject.length == 0 && projectList.length == 0) {
            return
        }
        setLoading(true);
        let params = {
            page: currentPage ? currentPage : page,
            pageSize: pageSize,
            projectCode: selectProject ? selectProject[0] : projectList[0].value,
            type: selectType[0],
            subjectCode: searchKey ? searchKey : null,
            subjectCodeOrder: currentSort
        }
        //重置状态
        setIsMore(true)
        api.getTasks(params).then(res => {
            if (res.code == '0') {
                let subjectArr = res.data
                setIsMore(subjectArr.length === pageSize)
                //重置
                if (isReset) {
                    setPage(subjectArr.length === pageSize ? 2 : 1);
                    setSubjectList(subjectArr);
                }
                else {
                    setPage(subjectArr.length === pageSize ? page + 1 : page);
                    setSubjectList([...subjectList, ...subjectArr]);
                }
            }
            setLoading(false);
        })
    }

    //当selectProject、selectState发生变化进行重新搜索
    useEffect(() => {
        
        getTasks(1, true);
        // let conditions = {
        //     selectProject: selectProject,
        //     selectType: selectType,
        //     currentSort: currentSort,
        // }
        // localStorage.setItem('conditionsStateLocal', JSON.stringify(conditions));
    }, [selectProject, selectType, currentSort])

    //当点击列表item
    const onClickListItem = (item: any) => {
        return () => {
            let urlHash = window.location.hash;
            // 点击条目跳转后返回选中当前转台
            if (selectProject && selectProject[0] == null) {
                // 选中全部
                if (props.fromHomeDoctor) {
                    window.history.replaceState({}, document.title, '#/doctor/home?tab=task')
                } else {
                    window.history.replaceState({}, document.title, '#/home')
                }
            } else if (urlHash.indexOf('?') > 0) {
                // 还原更新url参数
                let urlParam = urlHash.split('?')[1];
                if (urlParam) {
                    let urlParamArr = urlParam.split('&');
                    urlParamArr = urlParamArr.map(val => {
                        if (val.indexOf('projectCode') >= 0) {
                            return 'projectCode=' + item.projectCode;
                        } else if (val.indexOf('projectName') >= 0) {
                            return 'projectName=' + encodeURIComponent(item.projectName);
                        } else {
                            return val;
                        }
                    })
                    let afterUrl = urlParamArr.join('&');
                    if (props.fromHomeDoctor) {
                        window.history.replaceState({}, document.title, '#/doctor/home?' + afterUrl)
                    } else {
                        window.history.replaceState({}, document.title, '#/home?' + afterUrl);
                    }
                }
            } else {
                // url后没有数据的时候记录当前选中状态
                if (props.fromHomeDoctor) {
                    window.history.replaceState({}, document.title, `#/doctor/home?tab=task&projectCode=${item.projectCode}&projectName=${encodeURIComponent(item.projectName)}`)
                } else {
                    window.history.replaceState({}, document.title, `#/home?projectCode=${item.projectCode}&projectName=${encodeURIComponent(item.projectName)}`)
                }
            }
            setTimeout(() => {
                api.getPreSignStatus({
                    projectCode: item.projectCode
                }).then((res: any) => {
                    if (res.code == 0) {
                        const _data = res.data || {};
                        if (_data.status == 0) {
                            // 0未签署 1签署 为空的话就跳过判断
                            Modal.alert('', '当前选择的项目未签署服务协议，请签署服务协议后再进行操作。', [
                                {
                                    text: '取消', onPress: () => {
                                    }
                                },
                                {
                                    text: '立即签署', onPress: () => {
                                        props.history.push(`/doctor/laborAgreement?code=${_data.code}`);
                                    }
                                }
                            ])
                            return;
                        }
                        if (_data.auditStatus == 'REJECT') { // 'AGREE' 'RUNNING' 'REJECT'
                            Modal.alert('', '您签署的服务协议未通过审核，重新签名后方可继续使用完整功能。请您确保签名正确完整，清晰可辨认。', [
                                {
                                    text: '取消', onPress: () => {
                                    }
                                },
                                {
                                    text: '重新签署', onPress: () => {
                                        api.toGenerateAfreshSignLaborUserAgreement(_data.code).then((res: any) => {
                                            if (res.code == 0) {
                                                const _dataCode = res.data || '';
                                                props.history.push(`/doctor/laborAgreement?code=${_dataCode}`);
                                            } else {
                                                Toast.fail(res.message || '重新生成签署协议失败', 0.8);
                                            }
                                        })
                                    }
                                }
                            ])
                            return;
                        }
                    } else {
                        Toast.fail(res.message || '查询签署状态失败', 0.8);
                    }
                    const subjectScaleReportState = projectTypeMap?.[projectCode]?.subjectScaleReportState;
                    // 记录点击条目数据
                    item && sessionStorage.setItem('toPhotoEditItem', JSON.stringify({ ...item, subjectScaleReportState }));
                    if (item.subjectState === 'Init') {
                        props.history.push({ pathname: `/checkSubject/${item.subjectCode}`, search: `?projectType=${item.projectType}` })
                        sessionStorage.removeItem('currentState');
                    }
                    else {
                        if (roleCode === 'EDC_DRE') {
                            props.history.push({ pathname: `/subjectsDetailComment/${item.subjectCode}?projectType=${item.projectType}` })
                            sessionStorage.removeItem('currentState');
                        } else {
                            // 追加projectId 转移受试者
                            const stack = projectTypeMap as {[key:string]: any}
                            const key = item.projectCode as string

                            const { id } = stack[key]
                            
                            props.history.push({ pathname: `/subjectsDetail/${item.subjectCode}`, search: `?projectId=${id}&projectType=${item.projectType}` })
                            sessionStorage.removeItem('currentState');
                        }
                    }
                });
            }, 50);
        }
    }

    //当点击排序按钮
    const onClickSort = () => {
        if (currentSort === null) {
            setCurrentSort('ASC');
        }
        else if (currentSort === 'ASC') {
            setCurrentSort('DESC');
        }
        else if (currentSort === 'DESC') {
            setCurrentSort(null);
        }
    }

    //当进度长度为一条时
    const switchProgress = (progress: any) => {
        if (progress) {
            switch (progress[0]) {
                case 'Complete':
                    return (
                        <span style={{ backgroundColor: '#6c96f7', maxWidth: '0.8rem' }}></span>
                    )
                case 'Running':
                    return (
                        <span style={{ backgroundColor: '#52C41A', maxWidth: '0.8rem' }}></span>
                    )
                case 'Question':
                    return (
                        <span style={{ backgroundColor: '#ef8767', maxWidth: '0.8rem' }}></span>
                    )
                case 'Wait':
                    return (
                        <span style={{ backgroundColor: '#e6ebf5', maxWidth: '0.8rem' }}></span>
                    )
                case 'Answer':
                    return (
                        <span style={{ backgroundColor: '#477291', maxWidth: '0.8rem' }}></span>
                    )
                default:
                    break;
            }
        }
        else {
            return null
        }
    }

    //处理task状态
    const handleTask = (item: any) => {
        switch (item.type) {
            case 'Check':
                return (
                    <span style={{ color: '#FF8C69' }}>{item.message}</span>
                )
                break;
            case 'Question':
                return (
                    <span style={{ color: '#FF8C69' }}>{item.message}</span>
                )
                break;
            case 'Examine':
                return (
                    <span style={{ color: '#FF8C69' }}>{item.message}</span>
                )
                break;
            case 'Answer':
            case 'ImageAnswer':
                return (
                    <span style={{ color: '#eab426' }}>{item.message}</span>
                )
                break;
            default:
                return (
                    <span style={{ color: '#52C41A' }}>{item.message}</span>
                )
                break;
        }
    }

    //处理task颜色
    const handleTaskColor = (item: any) => {
        let _targetColor: any = {};
        switch (item.type) {
            case 'Check':
            case 'Question':
            case 'Examine':
                _targetColor = {
                    type: 'orange',
                    color: '#FF8C69'
                };
                break;
            case 'Answer':
                _targetColor = {
                    type: 'yellow',
                    color: '#eab426'
                };
                break;
            default:
                _targetColor = {
                    type: 'green',
                    color: 'rgb(94, 188, 188)'
                };
                break;
        }
        return _targetColor;
    }

    // 质疑排序
    const sortMethods = (data: any) => {
        data && data.length > 0 && data.map((dataItem: any, dataIndex: any) => {
            dataItem.tasks && dataItem.tasks.length > 0 && dataItem.tasks.map((taskItem: any, taskIndex: any) => {
                if (taskItem.type == "Answer") {
                    dataItem.tasks[0] = taskItem
                }
            })
        })
        return data
    }

    const dataView = new ListView.DataSource({
        rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    });

    const dataSource = dataView.cloneWithRows(sortMethods(subjectList));

    // 君实显示状态
    const takeVisitStatusName = (item: any)=> {
        return (
            <div className={styles.banner_text_visit}>
                <span>{item.visitStatusName}</span>
            </div>
        )
    }

    // 审核状态展示
    const takeAuditState = (item: any)=> {
        if (null === item.auditState) {
            return
        }

        const kv = {
            Pass: [icon_reviewed, styles.color_reviewed, '病例已审核'],
            Wait: [icon_to_be_reviewed, styles.color_to_be_reviewed, '病例待审核'],
            Fail: [icon_failed, styles.color_failed, '病例未通过']
        }

        type K = keyof typeof kv

        if (kv[ item.auditState as K]) {
            const [icon, className, text] = kv[ item.auditState as K]
            return (
                <div className={styles.banner_text_new}>
                    <img src={icon} alt="" />
                    <span className={className}>{text}</span>
                </div>
            )
        }
        return null
    }

    // 签名状态
    const takeSignState = (item: any) => {
        // 撤回知情同意状态优先
        if (item.subjectState === 'Withdraw') {
            return (
                <div className={styles.banner_text_new}>
                    <img src={icon_rz_fail} alt="" />
                    <span className={styles.color_rz_fail}>
                        撤回知情同意
                    </span>
                </div>
            )
        }
        
        if (item.subjectState === 'Finish' && item.signState == 'Wait') {
            return (
                <div className={styles.banner_text_new} style={{ top: item.auditState !== null ? 35 : 13 }}>
                    <img src={icon_not_signed} alt="" />
                    <span className={styles.color_complete}>
                        未签名
                    </span>
                </div>
            )
        }
        if (item.subjectState === 'Finish' && item.auditState === null) {
            return (
                <div className={styles.banner_text_new}>
                    <img src={icon_completed} alt="" />
                    <span className={styles.color_complete}>
                        已完成
                    </span>
                </div>
            )
        }
        if (item.subjectState === 'Active' && item.auditState === null) {
            return (
                <div className={styles.banner_text_new}>
                    <img src={icon_ing} alt="" />
                    <span className={styles.color_ing}>
                        进行中
                    </span>
                </div>
            )
        }

        if (item.subjectState === 'Pass') {
            return (
                <div className={styles.banner_text_new}>
                    <img src={icon_rz_fail} alt="" />
                    <span className={styles.color_rz_fail}>
                        入组筛选失败
                    </span>
                </div>
            )
        }
        return null
    }

    const row = (item: any) => (
        <div className={`${styles.list} ${selecProjectEntity.editModel === 1 ? styles.listJun: ''}`} onClick={onClickListItem(item)}>
            <div className={styles.listItem}>
                <div className={styles.portrait}>
                    <img src={defaultAvatar} alt="defaultAvatar" />
                    {selecProjectEntity?.editModel === 1  && item.bindState === 1 && 
                    <button
                        type="button"
                        className={styles.chat}
                        onClick={(event)=> {
                            event.stopPropagation()
                            setCreateUserCode(item.createUserCode)
                            setSubjectCode(item.subjectCode)
                            setShowChatModal(true)
                        }}>
                            <MessageOutline/>
                            {item.unread > 0 && <i>{item.unread}</i>}
                        </button>}
                </div>
                <div className={styles.info_content}>
                    <div className={styles.info_top}>
                        {/* {item.subjectName ? (
                            <div className={styles.id}>
                                <div className={styles.subName}>{item.subjectName}</div>
                                <div className={styles.subCode}>（&nbsp;{item.subjectCode}&nbsp;）</div>
                            </div>
                        ) : (
                            <div className={styles.id}>{item.subjectCode}</div>
                        )} */}
                        <div className={styles.id}>
                            <div className={styles.subName}>
                                {(localStorage.getItem('tenantCode') === 'TENANT-041' && !nameCodes.includes(item.projectCode))
                                   ? (item.subjectName || '暂无')
                                   : item.subjectCode}
                            </div>
                        </div>
                        <div className={styles.name}>{item.createUser}</div>
                        {
                            roleCode === 'EDC_DRE' && item.commentState &&
                            <div className={item.commentState === 'Finish' ? styles.commentStateFinish : styles.commentStateWait}>
                                <div className={styles.dot}></div>
                                {item.commentState === 'Finish' ? '已点评' : item.commentState === 'Wait' ? '待点评' : ''}
                            </div>
                        }
                    </div>
                    {localStorage.getItem('tenantCode') === 'TENANT-041' && !nameCodes.includes(item.projectCode) && (
                        <div className={styles.info_middle}>
                            <div className={styles.label}>
                            {item.subjectCode}
                            </div>
                        </div>
                    )}
                    
                    <div className={styles.info_middle}>
                        <div className={styles.label}>
                            {item.projectName}
                        </div>
                        <div className={styles.action} style={{ display: item.singleSignState == null ? 'none' : '' }}>
                            {
                                item.singleSignState == '1' ? <div className={styles.sign1}>
                                    <div className={styles.icon}></div>
                                    <div>&nbsp;已签名</div>
                                </div> : item.singleSignState == '2' ? <div className={styles.sign1}>
                                    <div className={styles.icon}></div>
                                    <div>&nbsp;签名已审</div>
                                </div> : item.singleSignState == '3' ? <div className={styles.sign2}>
                                    <div className={styles.icon}></div>
                                    <div>&nbsp;签名不合格</div>
                                </div> : <div className={styles.sign3}>
                                    <div className={styles.icon}></div>
                                    <div>&nbsp;待签名</div>
                                </div>
                            }
                            {/* {
                                item.auditState === 'Fail' &&
                                <span className={styles.answer}>!</span>
                            } */}
                            {/* {item.auditState !== 'Fail' &&
                                renderIconFont(item.tasks[0])
                            } */}
                        </div>
                    </div>
                    {item.groupName && <div className={styles.info_middle}>
                        <div className={styles.label}>
                            {item.groupName}
                        </div>
                    </div>}
                   
                    {
                        eproProjectCodes.includes(item.projectCode) && item.subjectName ? 
                        <div className={styles.info_middle}>
                             <div className={styles.label}>{targetName}简称：{item.subjectName}</div>
                        </div> : ''
                    }

                    {
                       selecProjectEntity?.editModel === 1  && item.subjectName?
                        <div className={styles.info_middle}>
                             <div className={styles.label}>{targetName}信息：{item.subjectName || "未知"}-{item.sex || "未知"}-{item.age ? item.age+"岁" : "未知"}</div>
                        </div> : ''
                    }
                    {
                        targetShow && 
                        <div className={styles.info_middle}>
                            <div className={styles.label}>●&nbsp;{item.centerName}</div>
                        </div>
                    }
                    {
                        showTasks(item)
                    }
                    <div className={styles.info_bottom}>
                        {
                            item.progress && item.progress.length > 1 ? item.progress.map((pro: any, i: any) => {
                                switch (pro) {
                                    case 'Complete':
                                        return (
                                            <span key={i} style={{ backgroundColor: '#6c96f7' }}></span>
                                        )
                                    case 'Running':
                                        return (
                                            <span key={i} style={{ backgroundColor: '#52C41A' }}></span>
                                        )
                                    case 'Question':
                                        return (
                                            <span key={i} style={{ backgroundColor: '#ef8767' }}></span>
                                        )
                                    case 'Wait':
                                        return (
                                            <span key={i} style={{ backgroundColor: '#e6ebf5' }}></span>
                                        )
                                    case 'Answer':
                                        return (
                                            <span key={i} style={{ backgroundColor: '#477291' }}></span>
                                        )
                                    default:
                                        break;
                                }
                            }) : <React.Fragment>
                                {
                                    switchProgress(item.progress)
                                }
                                {
                                    item.progress && item.progress.length > 0 ? <span className={styles.extra} style={{ backgroundColor: '#E6EBF5' }}></span> : null
                                }
                            </React.Fragment>
                        }
                    </div>
                </div>
            </div>
            {/* 审核状态 */}
            {
                roleCode !== 'EDC_DRE' &&
                <>
                    {/* {
                        item.auditState !== null &&
                        <div className={styles.banner}>
                            {
                                item.auditState == 'Pass' &&
                                <img src={audit_already} alt="" />
                            }
                            {
                                item.auditState == 'Wait' &&
                                <img src={audit_remain} alt="" />
                            }
                            {
                                item.auditState == 'Fail' &&
                                <img src={audit_no_pass} alt="" />
                            }
                        </div>
                    } */}
                    {/* {
                        item.subjectState === 'Finish' && item.signState == 'Wait' ? <div className={styles.banner}>
                            <div className={`${styles.banner_text} ${styles.noSign}`}>
                                未签署
                            </div>
                        </div> : item.subjectState === 'Finish' && item.auditState === null ? <div className={styles.banner}>
                            <div className={styles.banner_text}>
                                已完成
                            </div>
                        </div> : null
                    } */}
                    
                    {/* 核审状态 & 签名状态 */}
                    <div className={styles.banner_stack}>
                        { selecProjectEntity.editModel === 1 && takeVisitStatusName(item) }
                        { takeAuditState(item) }
                        { takeSignState(item) }
                    </div>
                </>
            }
        </div>
    )

    //下拉触底
    const onEndReached = () => {
        if (isMore) {
            //加载数据
            getTasks()
        }
    }

    //当删除历史记录
    const onDelectRecord = () => {
        setIsShowMask(false);
        alert('Delete', '确定删除？', [
            { text: '取消', onPress: () => console.log('cancel'), style: 'default' },
            {
                text: '确认', onPress: () => {
                    setIsShowMask(false)
                    setRecord([]);
                    localStorage.removeItem('search_history_records');
                }
            },
        ]);
    }

    //当点击记录
    const onClickRecord = (item: any) => {
        return () => {
            setSearchKey(item);
            setIsShowMask(false);
            setLoading(true);
            let params = {
                page: 1,
                pageSize: pageSize,
                projectCode: selectProject ? selectProject[0] : null,
                type: selectType[0],
                subjectCode: item,
                subjectCodeOrder: currentSort
            }

            //重置状态
            setIsMore(true)
            api.getTasks(params).then(res => {
                if (res.code == '0') {
                    let subjectArr = res.data;
                    setIsMore(subjectArr.length === pageSize)
                    //重置
                    setPage(subjectArr.length === pageSize ? 2 : 1);
                    setSubjectList(subjectArr);
                }
                setLoading(false);
            })
        }
    }

    //选择筛选类型
    const switchSort = () => {
        switch (currentSort) {
            case null:
                return (
                    <React.Fragment>
                        <img src={sort} alt="sort" />
                        <span className={styles.sort}>排序</span>
                    </React.Fragment>

                )
                break;
            case 'ASC':
                return (
                    <React.Fragment>
                        <img src={sort_asc} alt="sort_asc" />
                        <span className={styles.sort_asc}>排序</span>
                    </React.Fragment>
                )
                break;
            case 'DESC':
                return (
                    <React.Fragment>
                        <img src={sort_desc} alt="sort_desc" />
                        <span className={styles.sort_desc}>排序</span>
                    </React.Fragment>

                )
                break;
            default:
                break;
        }
    }

    // 渲染图标
    const renderIconFont = (stateItem: any) => {
        // 系统核查
        if (stateItem.type === 'Check') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconCheck_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconCheck_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconxitonghecha"></IconFont>
                    )
                case 'Question':
                    return (
                        <IconFont type="iconCheck_Question"></IconFont>
                    )
                default:
                    break;
            }
        }
        //录入
        else if (stateItem.type === 'Input') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconInput_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconInput_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconluru2"></IconFont>
                    )
                default:
                    break;
            }
        }
        //人工核查
        else if (stateItem.type === 'Question') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconQuestion_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconQuestion_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconrengonghecha"></IconFont>
                    )
                case 'Question':
                    return (
                        <IconFont type="iconQuestion_Question"></IconFont>
                    )
                case 'Answer':
                    return (
                        <IconFont type="iconQuestion_Answer"></IconFont>
                    )
                default:
                    break;
            }
        }
        //数据审查
        else if (stateItem.type === 'Examine') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconExamine_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconExamine_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconshujuhecha"></IconFont>
                    )
                case 'Question':
                    return (
                        <IconFont type="iconExamine_Question"></IconFont>
                    )
                case 'Answer':
                    return (
                        <IconFont type="iconExamine_Answer"></IconFont>
                    )
                default:
                    break;
            }
        }
        //冻结
        else if (stateItem.type === 'Freeze') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconFreeze_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconFreeze_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="icondongjie1"></IconFont>
                    )
                default:
                    break;
            }
        }
        //签名
        else if (stateItem.type === 'Autograph') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconAutograph_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconAutograph_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconqianming1"></IconFont>
                    )
                default:
                    break;
            }
        }
        //锁定
        else if (stateItem.type === 'Lock') {
            switch (stateItem.state) {
                case 'Complete':
                    return (
                        <IconFont type="iconLock_Complete"></IconFont>
                    )
                case 'Wait':
                    return (
                        <IconFont type="iconLock_Wait"></IconFont>
                    )
                case 'Running':
                    return (
                        <IconFont type="iconsuoding2"></IconFont>
                    )
                default:
                    break;
            }
        }
        //质疑
        else if (['Answer', 'ImageAnswer'].includes(stateItem.type)) {
            switch (stateItem.state) {
                case 'Question':
                    return (
                        <span className={`${styles.answer}`}>!</span>
                    )
                default:
                    break;
            }
        }
    }


    //改变邮箱地址
    const changeEmail = (event: any) => {
        setEmailAddress(event.target.value);
    }

    //关闭邮箱地址模态框
    const closeEmail = () => {
        setShowEmailModal(false)
    }

    //发送邮件
    const handleSendEmail = () => {
        let emailReg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (emailReg.test(emailAddress) == false) {
            Toast.info('邮箱格式不对，请重新输入！', 1)
            return false;
        }

        let params = {
            email: emailAddress
        }
        api.sendCaseEmail(params).then(res => {
            if (res.code == '0') {
                Toast.success('发送成功')
                closeEmail()
            }
        })
    }

    //获取病例发送邮箱
    const getCaseEmail = () => {
        api.getCaseEmail().then((res: any) => {
            if (res.code == '0' && res.data) {
                setEmailAddress(res.data)
            }
        })
    }
    //下载文件
    const  downLoadFile = ()=>{
        const url = 'https://huimei-edc.oss-cn-shanghai.aliyuncs.com/edc/data/image/TENANT-024/dsfsadfsaf.png'
        if(typeof window.wx.miniProgram.navigateTo === 'function') {
            window.wx.miniProgram.navigateTo({
                url: `/pages/download/download?url=${url}`,
                success() {
                  
                },
                fail() {
                    Modal.alert('提示', '下载文件失败')
                }
            })
        } else {
            // utils.downloadFile(casePreviewUrl)
            Modal.alert('提示', '请在小程序打开')
        }
    }  
    

    const showTasks = (item: any) => {
        let show = true
        // @20250213 fix:项目列表只读账号显示任务提示
        // if (projectList) {
        //     let Index = projectList.findIndex((v: any) => v.projectCode == item.code)
        //     if (projectList[Index] && projectList[Index].roleCode == 'ReadOnly') {
        //         show = false
        //     }
        // }
        if (mToken.roleCode == 'EDC_READ') {
            show = false
        }
        if (show) {
            return (
                item.tasks && item.tasks[0] && handleTask(item.tasks[0]) && renderIconFont(item.tasks[0]) &&
                <div className={`${styles.prompt_wrap}`} >
                    <div className={`${styles.prompt} ${styles[handleTaskColor(item.tasks[0]).type]}`} >
                        <div className={styles.action}>
                            {
                                item.auditState === 'Fail' &&
                                <span className={styles.answer}>!</span>
                            }
                            {item.auditState !== 'Fail' &&
                                renderIconFont(item.tasks[0])
                            }
                        </div>
                        {item.auditState === 'Fail' && roleCode !== 'EDC_DRE' && <span style={{ color: '#eab426' }}>您的任务审核未通过</span>}
                        {
                            ((item.auditState !== 'Fail' && item.commentState !== 'Finish') || item.commentState === 'Wait') && item.tasks && item.tasks.length > 0 ? handleTask(item.tasks[0]) : null
                        }
                    </div>
                </div>
            )
        }
    }

    return (
        <div className={`${styles.findTabItem} ${menuStatus ? '' : styles.hide_menu_btn}`}>
            <TabBar
                unselectedTintColor="#949494"
                tintColor="#33A3F4"
                barTintColor="white"
                tabBarPosition={'bottom'}
                hidden={!menuStatus}
            >
                <TabBar.Item
                    icon={<img src={mineIcon} width="20" alt="" />}
                    selectedIcon={<img src={mineSelectIcon} width="20" alt="" />}
                    title={"我的患者"}
                    key="mine"
                    selected={selectedTab == 'mine'}
                    onPress={() => {
                        setSelectedTab('mine')
                    }}
                >
                    <div className={styles.home_content}>
                        <div className={styles.header}>
                            {/* <div className={styles.searchBar}>
                                <SearchBar
                                    value={searchKey}
                                    placeholder={"查找任务"}
                                    onSubmit={onsubmit}
                                    onClear={value => console.log(value, 'onClear')}
                                    onFocus={() => setIsShowMask(true)}
                                    // onBlur={() =>  setIsShowMask(false)}
                                    onCancel={oncancel}
                                    onChange={onSearchChange}
                                />
                                <div className={styles.addSubject}>
                                    <Link to="/addSubject">
                                        <IconFont type="iconAdd"></IconFont>
                                    </Link>
                                </div>
                            </div> */}
                            {/* 遮罩层 */}
                            {
                                isShowMask ? <div onClick={() => { setIsShowMask(false) }} className={styles.mask}></div> : null
                            }
                            {/* 搜索历史记录 */}
                            {
                                isShowMask ? <div className={styles.record}>
                                    <div className={styles.record_head}>
                                        <div className={styles.record_head_title}>
                                            搜索记录
                                        </div>
                                        <span className={styles.record_head_delete} onClick={onDelectRecord}>
                                            <img src={deleteBtn} alt="delete" />
                                        </span>
                                    </div>
                                    <div className={styles.record_content}>
                                        {
                                            record && record.map((item: any, index: any) => {
                                                if (item) {
                                                    return <span key={index} onClick={onClickRecord(item)}>{item}</span>
                                                }
                                            })
                                        }
                                    </div>
                                </div> : null
                            }
                            <div className={styles.class_content}>
                                <div>
                                    <Picker data={projectList} title='选择项目' extra={selectProjectName} cols={1} onOk={onProjectOk} value={selectProject}>
                                        <List.Item arrow="down"></List.Item>
                                    </Picker>
                                </div>
                                <div>
                                    <Picker data={stateList} title='选择类型' extra="全部" cols={1} onOk={onTypeOk} value={selectType}>
                                        <List.Item arrow="down"></List.Item>
                                    </Picker>
                                </div>
                                <div className={styles.sort_content} onClick={onClickSort}>
                                    {
                                        switchSort()
                                    }
                                </div>
                            </div>
                        </div>
                        
                        {/* 统计栏 */}
                        <Stat projectCode={selecProjectEntity?.code} editModel={selecProjectEntity?.editModel}/>
                    
                        <div className={styles.task_list_search_header}>
                            <div className={styles.head}>
                                <div className={styles.title}    >
                                    项目列表
                                </div>
                              
                                <div className={styles.add_task_wrap} style={{ display: mToken.roleCode == 'EDC_READ' ? 'none' : '' }}>
                                    {hasSign && <div className={styles.add_task} onClick={() => setShowEmailModal(true)}>
                                        <img src={icon_plus} alt="" />
                                        <span className={styles.add_task_text}>待签名批量下载{hasSign}</span>
                                    </div>}
                                    {
                                        !addSubjectReadonly &&
                                        <div className={styles.add_task} onClick={() => { props.history.push('/addSubject'); }}>
                                            <img src={icon_plus} alt="" />
                                            <span className={styles.add_task_text}>添加项目</span>
                                        </div>
                                    }
                                </div>
                            </div>
                            <div className={styles.search}>
                                <div className={`${styles.tool_introduce_head}`}>
                                    <div className={styles.search_head}>
                                        <div className={styles.search}>
                                            <img className={styles.search_img} src={icon_search} alt="" />
                                            <input type="text" placeholder={`请输入${targetName}编号/姓名进行查找`} value={searchKey} onChange={(event) => { titleInput(event) }} />
                                            {
                                                searchKey &&
                                                <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={() => { clearInput() }} />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.List_content} ${props.bottomMore ? styles.list_content_more : ''}`}>
                            <ListView
                                // style={{ height: 'calc(100vh - 3.04rem)' }}
                                style={{ height: props.bottomMore ? 'calc(100vh - 7.1rem)' : 'calc(100vh - 5.98rem)' }}
                                dataSource={dataSource}
                                renderRow={row}
                                initialListSize={2000}
                                onEndReached={onEndReached}
                                onEndReachedThreshold={6}
                                scrollRenderAheadDistance={500}
                                scrollEventThrottle={200}
                                useBodyScroll={false}
                            // pullToRefresh={
                            //     <PullToRefresh
                            //         damping={60}
                            //         distanceToRefresh={25}
                            //         indicator={{}}
                            //         direction="down"
                            //         refreshing={isPullToRefresh}
                            //         getScrollContainer={() => undefined}
                            //         onRefresh={() => {
                            //             onPullToRefresh()
                            //         }}
                            //     >
                            //     </PullToRefresh>
                            // }
                            // renderFooter={() => (<div style={{ padding: 0, textAlign: 'center' }}>
                            //     {loading ? 'Loading...' : '已经到底了！'}
                            // </div>)}
                            />

                        </div>

                        {/* <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                            <Link to="/addSubject">
                                <img src={addBtn} alt="add" />
                            </Link>
                        </div> */}
                        {/* {
                            roleCode !== 'EDC_DRE' &&
                            <div className={styles.addAction} id="t-suspend-button" onTouchStart={(e) => onTouchStart(e)} onTouchMove={(e) => onTouchMove(e)} onTouchEnd={(e) => onTouchEnd(e)}>
                                <Link to="/addSubject" hidden={selectedTab == 'find'}>
                                    <div className={styles.addSubjectLink}>
                                        <div className={styles.addSubjectLeft}>
                                            <span>+</span>
                                        </div>
                                        <div className={styles.addSubjectRight}>
                                            <div>添加</div>
                                            <div>任务</div>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        } */}

                        <ActivityIndicator animating={loading} size={"small"} text={'正在加载数据'} toast />

                    </div >
                </TabBar.Item>

                <TabBar.Item
                    icon={<img src={findIcon} width="16" alt="" />}
                    selectedIcon={<img src={findSelectIcon} width="16" alt="" />}
                    title={"发现"}
                    key="find"
                    selected={selectedTab == 'find'}
                    onPress={() => {
                        setSelectedTab('find')
                    }}
                >
                    {selectedTab == 'find' && <FindListCom {...props} userId={userId} />}
                </TabBar.Item>
            </TabBar>


            <Modal visible={showEmailModal} className={styles.email_container}>
                <div className={styles.email_content}>
                    <img className={styles.email_icon} src={email_icon} alt="" />
                    <div className={styles.etitle}>接收病例邮箱地址</div>
                    <input type="text" placeholder="请输入邮箱地址" value={emailAddress} onChange={(event) => { changeEmail(event) }} />

                    <div className={styles.btns}>
                        <div className={styles.cancelBtn} onClick={closeEmail}>取消</div>
                        <div className={styles.sendBtn} onClick={handleSendEmail}>发送</div>
                    </div>
                </div>
            </Modal>

            {/* 聊天窗口 */}
            {
                showChatModal && (
                    <ChatModal createUserCode={createUserCode} subjectCode={subjectCode} onClose={()=> setShowChatModal(false)}/>
                )
            }

            {/* 齐鲁肿瘤 */}
            <QlAlert/>
        </div>
    )
}
export default withRouter(Home);